import startCase from 'lodash/startCase';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fsStateConvert',
})
export class FsStateConvertPipe implements PipeTransform {
  private shortToLongMap: { [abbr: string]: string } = {
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'American Samoa',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    FM: 'Federated States of Micronesia',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MH: 'Marshall Islands',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    MP: 'Northern Mariana Islands',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PW: 'Palau',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VI: 'Virgin Islands',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  };

  // pre-build the inverse object (long -> short), with the long form state name keys in lowercase
  private longToShortMap: { [name: string]: string } = Object.entries(this.shortToLongMap).reduce(
    (acc, [abbr, fullName]) => {
      acc[fullName.toLowerCase()] = abbr;
      return acc;
    },
    {} as { [name: string]: string },
  );

  /**
   * @param state    - The state value (short form e.g. 'NY' or long form e.g. 'New York')
   * @param toFormat - Accepts 'short', 'long', or 'clean' to determine the conversion type
   * @returns        - The converted string (or the original)
   */
  transform(state: string, toFormat: 'short' | 'long' | 'clean'): string {
    if (!state) {
      return state;
    }

    const isShort = state.length === 2;
    const isLong = state.length > 2;

    const toClean = toFormat === 'clean';
    const toShort = toFormat === 'short';
    const toLong = toFormat === 'long';

    // Formatting without conversion
    if (toClean || (isShort && toShort) || (isLong && toLong)) {
      return isShort ? state.toUpperCase() : startCase(state.toLowerCase());
    }

    if (toShort) {
      const longLowercase = startCase(state).toLowerCase(); // Handle cases such as new_york, new-york, etc.
      return this.longToShortMap[longLowercase] || state;
    }

    if (toLong) {
      const shortUppercase = state.toUpperCase();
      return this.shortToLongMap[shortUppercase] || state;
    }

    return state;
  }
}
